import React from "react";
import './InputText.scss'



const InputText = ({ type="text",title = "title", obligatorio = false, placeholder, id, onChange,value,disabled,style,onBlur,autoFocus,min,max }) => {
    return (
        <div className="InputText" style={style}>
            <div className="contenedorTitulo">
                {
                    obligatorio ?
                    <>
                            <div className="obligatorio">*</div>
                        </>:null
                }
                <div className="titulo">{title}</div>
            </div>
            <input type={type} min={min} max={max} onBlur={onBlur} disabled={disabled} value={value} id={id} onChange={onChange} placeholder={placeholder} autoFocus={autoFocus}  className="InputText" />
        </div>
    )
}
export default InputText